import ButtonScrollTo from "components/button-scroll-to/ButtonScrollTo";
import useIsMobile from "hooks/useIsMobile";

export type ReviewHeaderProps = {
    title: string;
};

const desktopText = (
    <p className="text-white font-normal m-0 p-0 leading-[100%] tracking-[0%] capitalize text-center text-5xl">
        are you ready to help secure <br />
        your family's financial future?
    </p>
);

const mobileText = (
    <p className="text-white font-semibold m-0 p-0 leading-[36px] tracking-[0%] capitalize text-center text-[30px]">
        are you ready to <br />
        protect your <br />
        family's future?
    </p>
);

const ReadyBanner = () => {
    const isMobile = useIsMobile();

    return (
        <div className="card tablet:h-[316px] h-[216px] rounded-none bg-base-content w-full flex justify-center items-center">
            <div className="w-full max-w-content flex flex-col justify-center items-center gap-4">
                {isMobile ? mobileText : desktopText}
                <ButtonScrollTo id="term-banner-content" text="Select My Coverage" />
            </div>
        </div>
    );
};

export default ReadyBanner;
